<!--
    27-02: Filtrado de boletas disponibles desde API
    06-03-2026: Preparado para lanzamiento a producción, se comenta código de prueba y se ajusta mensaje de alerta para Safari.

    -->
<template>
    <div>
        <v-container v-if="loadSkeleton">
            <SkeletonLoader tipo="table-heading, list-item-three-line" ruta="turnos" />
        </v-container>
        <v-container v-else class="d-flex flex-column custom-content-padding" style="min-height: 100vh;">
            <DialogoConfirmar ref="dialogConf" :msg="msg" :msgAceptar="msgAceptar" :msgCancelar="msgCancelar" />
            <DialogoLlamame ref="llamar" :titulo="this.titulo" />
            <DialogoMercadoPago ref="dialMercadoPago" @returnDialogoMP="goToCheckOut" :origen="fuenteOrigen"
                :orden="orden" />
            <v-card flat>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-card-title class="text-h5 font-weight-bold">
                            <v-icon color="primary" class="mr-3" size="34">{{ icon }}</v-icon>
                            Realizar pagos
                        </v-card-title>
                    </v-col>

                    <!-- No mostrar mensaje-->
                    <!--                     
                    <v-col v-if="$device.browser.safari ||
                        $device.browser.safari_mobile" cols="12" md="12" class="my-0">
                        <v-alert type="warning" :value="true" dense class="rounded-0" icon="mdi-information-outline"
                            color="orange darken-2">
                            <div class="font-weight-regular text-body-1">
                                Estás utilizando Safari. El pago en línea <b>no funciona en Safari</b>. Por favor,
                                utilizá Google Chrome o Mozilla Firefox para realizar el pago.
                            </div>
                        </v-alert>
                    </v-col> -->

                </v-row>
                <v-card class="d-flex flex-column mt-5" flat v-if="hayOrdenPagoActiva">
                    <v-card-text>
                        <v-alert colored-border color="orange darken-3" border="left" icon="mdi-alert" elevation="0"
                            dense
                            class="px-5 my-0 rounded-0 font-weight-regular text-body-1 orange--text text--darken-3"
                            style="word-break: keep-all;">
                            <div class="font-weight-regular text-body-1">
                                {{ mensajeError }}
                            </div>
                        </v-alert>
                    </v-card-text>
                </v-card>
                <v-card flat v-else-if="mensajeNoPuedePagar">
                    <v-card-text>
                        <v-alert type="warning" :value="true" dense class="rounded-0" icon="mdi-information-outline"
                            color="orange darken-2">
                            <div class="font-weight-regular text-body-1">
                                {{ mensajeNoPuedePagar }}
                            </div>
                        </v-alert>
                    </v-card-text>
                </v-card>
                <v-card class="d-flex flex-column" flat v-else>
                    <div v-if="tienedeuda == 3">
                        <DeudaCard />
                    </div>
                    <v-card flat class="rounded-0" style="border: 1px solid #f0f0f0;">
                        <v-card-text class="ma-0 pa-0">
                            <v-card class="d-flex align-center justify-center"
                                :class="$vuetify.breakpoint.xsOnly ? 'mx-9' : 'mx-2'" flat>
                                <v-btn fab x-small color="primary" :disabled="tab <= 0" @click="tab--"
                                    style="z-index: 3;">
                                    <v-icon color=" white">mdi-chevron-left</v-icon>
                                </v-btn>
                                <v-tabs v-model="tab" :centered="!$vuetify.breakpoint.xsOnly">
                                    <v-tab>
                                        <v-avatar color="primary" size="30" class="mr-2 white--text">
                                            <v-progress-circular v-if="loadingDeuda" indeterminate size="20" width="2"
                                                color="white"></v-progress-circular>
                                            <span v-else>{{ cantConceptosVencidos }}</span>
                                        </v-avatar>
                                        CONCEPTOS ADEUDADOS
                                    </v-tab>
                                    <v-tab>
                                        <v-avatar color="primary" size="30" class="mr-2 white--text">
                                            <v-progress-circular v-if="loadingDeuda" indeterminate size="20" width="2"
                                                color="white"></v-progress-circular>
                                            <span v-else>{{ cantConceptosNoVencidos }}</span>
                                        </v-avatar>
                                        CONCEPTOS A VENCER
                                    </v-tab>
                                    <v-tab>
                                        <v-avatar color="primary" size="30" class="mr-2 white--text">
                                            <v-progress-circular v-if="loadingDeuda" indeterminate size="20" width="2"
                                                color="white"></v-progress-circular>
                                            <span v-else>{{ cantConceptosDebitoAuto }}</span>
                                        </v-avatar>
                                        ADHERIDOS A DÉBITO AUTOMÁTICO
                                    </v-tab>
                                </v-tabs>
                                <v-btn fab x-small color="primary" :disabled="tab >= 2" @click="tab++"
                                    style="z-index: 3">
                                    <v-icon color="white">mdi-chevron-right</v-icon>
                                </v-btn>
                            </v-card>
                            <v-progress-linear v-if="loadingDeuda" indeterminate height="5"
                                color="primary"></v-progress-linear>
                            <v-card outlined v-if="loadingDeuda" class="ma-3 py-2 rounded-0">
                                <v-skeleton-loader class="mx-2 my-2"
                                    type="table-heading, list-item-two-line, list-item-two-line" :loading="true"
                                    height="200px">
                                </v-skeleton-loader>
                            </v-card>
                            <v-tabs-items v-else v-model="tab">
                                <v-tab-item>
                                    <v-card elevation="0" v-if="(Object.keys(conceptosVencidos).length !== 0)">
                                        <TablaConceptosPrueba ref="vencidos" @update-total="actualizarTotal"
                                            :showSelect="allowSelection && !loading" tipo="vencido"
                                            :items="conceptosVencidos" :headers="headerVencidos">
                                        </TablaConceptosPrueba>
                                    </v-card>
                                    <v-card v-else-if="!loadingDeuda && Object.keys(conceptosVencidos).length === 0"
                                        class="rounded-0" elevation="0">
                                        <v-card-text>
                                            <v-alert type="primary" outlined :value="true" dense class="rounded-0"
                                                :icon="iconAdeudado" :color="colorAdeudado">
                                                {{ labelAdeudado }}
                                            </v-alert>
                                        </v-card-text>
                                    </v-card>
                                    <v-card-text>
                                        <v-alert colored-border color="orange darken-3" border="left" icon="mdi-alert"
                                            elevation="0" dense
                                            class="px-5 my-0 rounded-0 font-weight-regular text-body-1 orange--text text--darken-3"
                                            style="word-break: keep-all;">
                                            La ausencia de conceptos adeudados no excluye la existencia de obligaciones
                                            pendientes de
                                            pago.
                                        </v-alert>
                                    </v-card-text>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card v-if="(Object.keys(conceptosNoVencidos).length !== 0)" class="rounded-0"
                                        elevation="0">
                                        <v-card-text v-if="(Object.keys(cantConceptosNoVencidos).length !== 0)">
                                            <v-alert type="warning" :value="true" color="orange darken-2" dense
                                                icon="mdi-information" class="rounded-0">
                                                Tenés conceptos adheridos a debito automático.
                                            </v-alert>
                                        </v-card-text>
                                        <v-card v-else class="rounded-0" elevation="0">
                                            <TablaConceptosPrueba ref="noVencidos" :items="conceptosNoVencidos"
                                                tipo="noVencido" :headers="headerNoVencidos"
                                                :showSelect="allowSelection && !loading"
                                                @update-total="actualizarTotal">
                                            </TablaConceptosPrueba>
                                        </v-card>
                                    </v-card>
                                    <v-card v-else-if="!loadingDeuda && Object.keys(conceptosNoVencidos).length === 0"
                                        class="rounded-0" elevation="0">
                                        <v-card-text>
                                            <v-alert type="primary" outlined :value="true" dense class="rounded-0"
                                                icon="mdi-check-circle-outline" color="secondary">
                                                No tenés conceptos por vencer.
                                            </v-alert>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card v-if="(Object.keys(conceptosDebitoAuto).length !== 0)" class="rounded-0"
                                        elevation="0">
                                        <v-card class="rounded-0" elevation="0">
                                            <TablaConceptosPrueba :headers="headerDebitoAuto"
                                                :items="conceptosDebitoAuto" hide-default-header hide-default-footer
                                                tipo="debitoAuto" :showSelect="false" class="elevation-1">
                                            </TablaConceptosPrueba>
                                        </v-card>
                                    </v-card>
                                    <v-card v-else-if="!loadingDeuda && Object.keys(conceptosDebitoAuto).length === 0"
                                        class="rounded-0" elevation="0">
                                        <v-card-text>
                                            <v-alert type="primary" outlined :value="true" dense class="rounded-0"
                                                icon="mdi-check-circle-outline" color="secondary">
                                                No tenés conceptos adheridos a débito automático.
                                            </v-alert>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-card>
            <v-card class="pa-4 rounded-0 custom-card-actions-ha" color="white"
                :style="{ left: $vuetify.application.left + 'px', height: 'auto' }">
                <v-row>
                    <v-col cols="12" md="12" class="d-flex align-center my-0 py-0"
                        :class="$vuetify.breakpoint.mdAndUp ? 'justify-start' : 'justify-space-between'">
                        <div class="font-weight-bold black--text text-body-1">
                            Total a pagar:
                        </div>
                        <div class=" font-weight-bold primary--text text-h5 ml-5  ">
                            {{ formatCurrency(totalSeleccionadoGeneral) }}
                        </div>
                    </v-col>
                    <v-col cols="12" md="12"
                        :class="$vuetify.breakpoint.mdAndUp ? 'd-flex justify-end' : 'd-flex justify-end'">
                        <v-btn v-if="!esJubilado" class="pa-5 font-weight-bold text-caption elevation-0 mr-2"
                            color="secondary" outlined width="150px" @click="goToPP">
                            <v-icon class="mr-1">mdi-chevron-right</v-icon>
                            FINANCIAR
                        </v-btn>
                        <v-btn v-if="!esModoGestion" :loading="loading" @click="irAPagar" color="primary"
                            :disabled="loading || (totalSeleccionadoGeneral == 0)"
                            class="pa-5 elevation-0 font-weight-bold text-caption white--text" width="150px">
                            <v-icon>mdi-chevron-right</v-icon>
                            Pagar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex';
import FormBoletas from '@/components/forms/FormBoletas.vue';
import DeudaCard from '@/components/cards/DeudaCard.vue'

import TablaConceptosPrueba from '@/views/TablaConceptosPrueba.vue'
import FormResumenAportes from '@/components/forms/FormResumenAportes.vue';
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue';
import DialogoMercadoPago from '@/components/dialogos/DialogoMercadoPago.vue';
import DialogoConfirmar from '@/components/dialogos/DialogoConfirmar.vue';
import DialogoLlamame from '@/components/dialogos/DialogoLlamame.vue';

export default {
    name: "Boletas",
    components: {
        ValidationObserver,
        ValidationProvider,
        FormBoletas,
        DeudaCard,
        DialogoMercadoPago,
        MercadoPago,
        DialogoConfirmar,
        FormResumenAportes,
        DialogoLlamame,
        TablaConceptosPrueba,
        SkeletonLoader
    },
    data() {
        return {
            orden: {
                nroafi: '',
                conceptos: [],
                origen: '' // mobile o desktop
            },
            tab: 0,
            conceptos: [],
            textoBtnMp: "Pagar con Mercado Pago",
            titulo: "",
            totalVencidos: 0,
            totalNoVencidos: 0,
            isLoading: false,

            selectedConceptos: [],
            pruebaConceptos: [],

            singleSelect: false,
            msg: '',
            msgAceptar: '',
            msgCancelar: '',
            allowSelection: true,

            itemsDeuda: [],
            loading: false,

            //FormBoletas
            valores: [],
            selectedItem: [],
            imprimir: {
                //url: '',
                //EN USO
                descargarPdf: 0,
                tipo_aporte: '',
                tipo_frm: 1,
                nro_afi_listado: '',

                //REVISAR
                nro_afi_add: '',
                nro_afi_desde: '',
                nro_afiliado: '',
                tpapo: '',
                nroafilia: '',
                autos: '',
                tipo_pericia: 1,
                totregulado: '',
                fpago: '',
                reimpresion: 0,
            },

            headerNoVencidos: [
                { text: 'Seleccionar', value: 'data-table-select', sortable: false, align: 'center', class: 'primary--text  font-weight-bold' },
                { text: 'MES/CUOTA', value: 'pmp_mes_cuota', align: 'center' },
                { text: 'FECHA DE VENCIMIENTO', value: 'pmp_fecha_vencimiento', align: 'center' },
                { text: 'IMPORTE', value: 'pmp_apagar', align: 'center' },
                { text: 'DESCARGA', value: 'action', align: 'center', sortable: false }  // Columna para el botón de descargar
            ],
            headerVencidos: [
                { text: 'Seleccionar', value: 'data-table-select', sortable: false, align: 'center' },
                { text: 'MES/CUOTA', value: 'pmp_mes_cuota', align: 'center' },
                { text: 'FECHA DE VENCIMIENTO', value: 'pmp_fecha_vencimiento', align: 'center' },
                { text: 'IMPORTE', value: 'pmp_apagar', align: 'center' },
                { text: 'DESCARGA', value: 'action', align: 'center', sortable: false }  // Columna para el botón de descargar
            ],
            headerDebitoAuto: [
                { text: 'MES/CUOTA', value: 'pmp_mes_cuota', align: 'center' },
                //   { text: 'FECHA DE VENCIMIENTO', value: 'pmp_fecha_vencimiento', align: 'center' },
                { text: 'IMPORTE', value: 'pmp_apagar', align: 'center' },
                { text: 'OBSERVACION', value: 'pmp_observaciones', align: 'center' },
                /*   { text: 'DESCARGA', value: 'action', align: 'center', sortable: false }  */ // Columna para el botón de descargar
            ],
        }
    },
    watch: {
        // Observar el valor de isLoading para limpiar la selección de conceptos en cada tabla
        isLoading(newValue) {
            if (!newValue) {
                if (this.$refs.vencidos) {
                    this.$refs.vencidos.selected = [];
                }
                if (this.$refs.noVencidos) {
                    this.$refs.noVencidos.selected = [];
                }
                this.selectedConceptos = [];
            }
            //  this.setDefaultTab()
        },

    },
    mounted() {
    },
    methods: {
        ...mapActions('auth', ['refreshToken']),
        ...mapActions('notificaciones', ['showSnack']),
        ...mapActions('boletas', ['getResumenAportes', 'generarOrder', 'actualizarOrdenPago', 'caducarOrdenPago', 'consultarOrdenActiva']),
        formatCurrency(value) {
            return value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
        },
        updateSelectedItem() {
            const vencidosSeleccionados = this.$refs.vencidos ? this.$refs.vencidos.selected : [];
            const noVencidosSeleccionados = this.$refs.noVencidos ? this.$refs.noVencidos.selected : [];
            this.selectedConceptos = [...vencidosSeleccionados, ...noVencidosSeleccionados].map(item => ({ pmp_id: item.pmp_id }))
        },
        setDefaultTab() {
            const tabs = [
                { count: this.cantConceptosVencidos, index: 0 },
                { count: this.cantConceptosNoVencidos, index: 1 }
            ];
            const maxTab = tabs.reduce((prev, current) => current.count > prev.count ? current : prev, tabs[0]);
            this.tab = maxTab.count > 0 ? maxTab.index : 0;
        },

        actualizarTotal() {
            const vencidosComponent = this.$refs.vencidos;
            const noVencidosComponent = this.$refs.noVencidos;

            this.totalVencidos = vencidosComponent ? vencidosComponent.totalSeleccionado : 0;
            this.totalNoVencidos = noVencidosComponent ? noVencidosComponent.totalSeleccionado : 0;
        },
        // Método para personalizar el encabezado de agrupación
        groupHeaderSlot({ group }) {
            // Retorna el texto personalizado para cada grupo
            return `Tipo de aporte: ${group}`;
        },
        // Método para determinar si una fila está deshabilitada
        lanzarDialogo() {
            this.$refs.llamar.abrirDialogo()
        },
        irAPagar() {
            this.loading = true;
            this.allowSelection = false;
            this.updateSelectedItem()
            this.orden = {
                nroafi: this.nroafi,
                conceptos: this.selectedConceptos,
                origen: this.fuenteOrigen //mobile o desktop
            }
            /*             if (this.orden.conceptos.length == 0) {
                            this.showSnack({ type: '400', message: 'No hay conceptos seleccionados para pagar.' });
                            this.loading = false;
                            this.allowSelection = true;
                            return;
                        } */
            this.$refs.dialMercadoPago.abrirDialogo().then((result) => {
                if (result) {
                    this.allowSelection = true;
                    this.totalVencidos = 0;
                    this.totalNoVencidos = 0;
                    this.loading = false;
                    this.updateSelectedItem();
                    // Deseleccionar los elementos seleccionados en ambas tablas
                    if (this.$refs.vencidos) {
                        this.$refs.vencidos.selected = [];
                    }
                    if (this.$refs.noVencidos) {
                        this.$refs.noVencidos.selected = [];
                    }
                    this.selectedConceptos = [];
                }
                location.reload();
            })
        },
        goToCheckOut(value) {
            this.loading = true;
            this.updateSelectedItem()
            window.location.href = value;
        },
        goToPP() {
            this.$router.push('/PlanesDePago').catch(() => { })
        },

    },

    computed: {
        ...mapGetters('auth', ['isAuthenticated', 'loadSkeleton', 'nroafi', 'user', 'tienedeuda', 'esJubilado', 'esModoGestion']),
        ...mapGetters('boletas', ['conceptosTotal', 'conceptosDebitoAuto', 'conceptosNoVencidos', 'conceptosBloqueados', 'labelBloqueo', 'conceptosVencidos', 'ordenPago', 'hayConceptosDeuda', 'urlMercadoPago', 'ordenPagoActiva', 'hayOrdenPagoActiva', 'url', 'isLoading', 'ordenPago', 'loadingDeuda', 'mensajeError', 'mensajeNoPuedePagar']),
        labelAdeudado() {
            return this.conceptosBloqueados.length !== 0 ? 'Tu solicitud de Financiación de Aportes Mensuales ha sido enviada, la misma permanece sujeta a revisión por parte de las áreas correspondientes.' : 'No tenés conceptos adeudados.';
        },
        colorAdeudado() {
            return this.conceptosBloqueados ? 'secondary' : 'secondary';
        },
        iconAdeudado() {
            return this.conceptosBloqueados ? 'mdi-information-outline' : 'mdi-check-circle-outline';
        },
        totalApagar() {
            return this.conceptos.reduce((sum, item) => sum + item.pmp_apagar, 0,);
        },
        isSmallScreen() {
            return this.$vuetify.breakpoint.smAndDown;
        },
        // Sumar el total seleccionado de ambos componentes
        totalSeleccionadoGeneral() {
            return this.totalVencidos + this.totalNoVencidos;
        },
        cantConceptosVencidos() {
            return this.conceptosVencidos.length;
        },
        cantConceptosNoVencidos() {
            return this.conceptosNoVencidos.length;
        },
        cantConceptosDebitoAuto() {
            return this.conceptosDebitoAuto.length
        },
        icon() {
            return 'mdi-list-box-outline'
        },
        fuenteOrigen() {
            return this.$device.isMobile ? 'mobile' : 'desktop';
            //return 'mobile';
        }
    }
};
</script>

<style>
.custom-card-actions-ha {
    position: fixed;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    left: 0;
    /* Altura suficiente para el contenido y centrado vertical */
}

/* Espacio para que el contenido no quede tapado por el footer */

.custom-content-padding {
    padding-bottom: 120px !important;
}

.custom-card {
    cursor: default;
    padding-bottom: 100px;
    /* Espacio suficiente para las acciones */
}

.v-slide-group__prev {
    display: none !important;
}
</style>